export const environment = {
    production: true,
    url: 'https://backapphub.azurewebsites.net',
    url_socket: 'http://localhost:3000'
};
